import { Pipe, PipeTransform, inject } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { FormErrors } from 'shared-ui/providers/form-errors';

@Pipe({
  name: 'formError',
  standalone: false,
})
export class FormErrorPipe implements PipeTransform {
  private formErrors = inject(FormErrors);

  transform(value: ValidationErrors | null | undefined): string {
    return this.formErrors.getError(value ?? null);
  }
}
